import { Box, Typography, Grid, Chip, Divider, Paper } from "@mui/material"

const KobiCV = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f0f4ff", // subtle background to make the paper pop
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2, // for small screen spacing
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          bgcolor: "background.paper", // או '#fff'
          maxWidth: "1200px",
          width: "100%",
        }}
      >
        <Box textAlign='center' mb={2}>
          <Typography variant='h4' color='primary' fontWeight='bold'>
            Kobi Shunak
          </Typography>
          <Typography variant='subtitle1' color='text.secondary'>
            Full-Stack Developer (Front-Oriented)
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2}>
          {/* Left Column */}
          <Grid item xs={12} md={4}>
            <Box>
              <Typography variant='h6' color='secondary'>
                Contact
              </Typography>
              <Typography>054-4901067</Typography>
              <Typography>wishgoods@gmail.com</Typography>
              <a
                href='https://www.linkedin.com/in/kobi-sci'
                target='_blank'
                rel='noopener noreferrer'
              >
                LinkedIn
              </a>
            </Box>

            <Box mt={3}>
              <Typography variant='h6' color='secondary'>
                Languages
              </Typography>
              <Typography>Hebrew: Native</Typography>
              <Typography>English: Professional</Typography>
            </Box>

            <Box mt={3}>
              <Typography variant='h6' color='secondary'>
                Tools
              </Typography>
              {[
                "React",
                "React Native",
                "Material UI",
                "NodeJS",
                "TypeScript",
                "MongoDB",
                "Socket.IO",
                "REST API",
                "GitHub",
                "TFS",
                "Postman",
                "Webpack",
                "C#",
                ".NET Core",
                "MSSMS",
                "SQL",
                "Figma",
              ].map((tool) => (
                <Chip
                  key={tool}
                  label={tool}
                  size='small'
                  color='primary'
                  sx={{ mr: 1, my: 0.5 }}
                />
              ))}
            </Box>

            <Box mt={3}>
              <Typography variant='h6' color='secondary'>
                Qualities
              </Typography>
              <ul>
                <li>Excellent self-learner</li>
                <li>Creative and motivated</li>
                <li>Strong social and problem-solving skills</li>
              </ul>
            </Box>

            <Box mt={3}>
              <Typography variant='h6' color='secondary'>
                Hobbies
              </Typography>
              <Typography>🎸 Guitar & music</Typography>
              <Typography>🎮 Gaming (PS)</Typography>
              <Typography>🌿 Nature & travel</Typography>
              <Typography>🧗 Rock climbing</Typography>
            </Box>

            <Box mt={3}>
              <Typography variant='h6' color='secondary'>
                Military Service
              </Typography>
              <Typography>Rifle Simulator Technician, Instructor, Special Ops Trainer</Typography>
              <Typography>2003–2006</Typography>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={8}>
            <Box>
              <Typography variant='h6' color='secondary'>
                Experience
              </Typography>

              {[
                {
                  title: "Sharie — Front-End Developer",
                  date: "2025 – Present",
                  bullets: [
                    "Developed complete web solution end to end with React-MUI,Nodejs and MongoDB.",
                    "Implemented and designed UI/UX.",
                    "Deployed complete web solution.",
                    "Implemented security aspects.",
                  ],
                },
                {
                  title: "SafeAI — Front-End Team Manager",
                  date: "2024 – 2025",
                  bullets: [
                    "Developed Flutter app with designers and PMs",
                    "Implement and maintain code quality standards, including code reviews.",
                    "Reported to CEO in agile startup environment.",
                    "Implemented code and security standards ",
                  ],
                },
                {
                  title: "Made4Net — Full-Stack Lead Developer",
                  date: "2021 – 2024",
                  bullets: [
                    "Led a small dev team with mission planning, we created React Native app from scratch.",
                    "Created hardware integrations and WebForms apps",
                    "Created Jquery solution with Canvas.",
                    "Created a Machine Learning model for Android project",
                  ],
                },
                {
                  title: "IPI — Full-Stack Developer",
                  date: "2018 – 2021",
                  bullets: [
                    "Collaborated with designers, architects, and product managers to build scalable applications using Angular, ensuring high code integrity.",
                    "Built scalable Angular applications",
                    "Created C# desktop WinForms multithreading solutions.",
                  ],
                },
                {
                  title: "NessIT — Tech Instructor",
                  date: "2015 – 2018",
                  bullets: [
                    "Taught science topics to youth",
                    "Led team projects and innovation workshops",
                  ],
                },
                {
                  title: "Extreme Games Instructor",
                  date: "2010 – 2015",
                  bullets: [
                    "Marketing, sales, lectures and course delivery",
                    "Client communication and business ops",
                  ],
                },
              ].map((exp, idx) => (
                <Box my={2} key={idx}>
                  <Typography variant='subtitle1' fontWeight='bold'>
                    {exp.title}
                  </Typography>
                  <Typography variant='caption'>{exp.date}</Typography>
                  <ul>
                    {exp.bullets.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </Box>
              ))}
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box>
              <Typography variant='h6' color='secondary'>
                Education
              </Typography>
              <Typography fontWeight='bold'>B.Sc – Computer Science, 2012 – 2016</Typography>
              <Typography>OOP, Data Structures, Algorithms, Java, Python (Eclipse)</Typography>

              <Typography fontWeight='bold' mt={2}>
                Open University – Full-Stack Developer, 2016 – 2017
              </Typography>
              <Typography>Angular, ASP.NET, WPF, HTML/CSS/JS, Azure, Bootstrap, jQuery</Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

export default KobiCV
